<template>
  <div>
    <el-dialog
      :visible.sync="showprint"
      :close-on-click-modal="false"
      class="dialog"
      append-to-body
      top="30px"
      width="500px"
      @close="closeShow"
    >
      <span slot="title" class="dialog-title">选择模板</span>
      <span>
        打印模板
        <el-select
          @change="printChange"
          v-model="def"
          style="width: 300px; margin-left: 10px"
          size="small"
        >
          <el-option
            v-for="item in list"
            :value="item.printTemplateDetails"
            :label="item.sysPrintName"
            :key="item"
          >
            <div style="display: flex">
              <div style="flex: 1">{{ item.sysPrintName }}</div>
              <div style="font-size: 0.5; color: cadetblue">
                {{ item.sysPrintType }}
              </div>
            </div>
          </el-option>
        </el-select>
        <printHistory
          :printModule="printModule"
          :modules="modules"
          :printFun="printFun"
        ></printHistory>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeShow">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="print()">确 定</el-button>
      </span>
    </el-dialog>
    <print-preview ref="preView" :modules="modules" :printModule="printModule" />
    <vue-easy-print style="display: none" tableShow ref="easyPrint">
      <div id="printArea" v-html="htmlData"></div>
    </vue-easy-print>
  </div>
</template>

<script>
import { sysPrint_getDefaultByModules, sysPrint_list } from '@/api/myController/system';
import vueEasyPrint from 'vue-easy-print';
import printPreview from '@/views/supplier/preview';
import printHistory from './printHistory';
import { print, printDataParse } from '@/utils/print';
let hiprintTemplate;
export default {
  components: { vueEasyPrint, printPreview, printHistory },
  props: {
    // 打印接口参数
    modules: {
      type: Number,
      required: false,
      default: 0
    },
    // 打印框显示
    showprint: {
      type: Boolean,
      required: false,
      default: false
    },
    // 打印接口加载
    btnLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    htmlDataList: {
      type: String,
      required: false,
      default: ''
    },
    // table多选数据
    changeList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    // 打印数据
    printData: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    printFun: {
      type: Function,
      required: false,
      default: null
    }
  },
  data() {
    return {
      isOld: false,
      list: [],
      htmlData: null,
      printModule: {},
      def: null
    };
  },
  mounted() {
    this.printGetList();
  },
  methods: {
    closeShow() {
      this.$emit('close');
    },
    async print() {
      if (this.btnLoading) {
        this.$message.warning('加载中');
        return;
      }
      if (this.def == null) {
        this.$message.warning('未选择打印模板');
        return;
      }
      if (this.changeList.lenth == 0) {
        this.$message.warning('未选择数据');
        return;
      }
      if (this.isOld) {
        const { href } = await this.$router.resolve({
          path: '/startPrint',
          query: { value: this.htmlDataList }
        });
        window.open(href);
      } else {
        setTimeout(() => {
          this.$refs.preView.show(hiprintTemplate, this.printData);
          setTimeout(() => {
            this.printData.totals += 111;
          }, 5000);
        }, 500);
      }
    },
    printChange(e) {
      this.htmlData = e;
      this.def = e;
      this.printModule = this.list.filter((a) => a.printTemplateDetails == e)[0];

      this.isOld = this.htmlData.includes('printTable');
      if (!this.isOld) {
        var panel = JSON.parse(this.htmlData);
        hiprintTemplate = new hiprint.PrintTemplate({
          template: panel
        });
      }
    },
    // 读出打印模板
    printGetList() {
      sysPrint_list({
        sysPrintDtoFilter: { modules: this.modules },
        pageParam: { total: 0, pageNum: 1, pageSize: 200 }
      }).then((res) => {
        this.list = res.data.data.dataList;
        this.list.forEach((it) => {
          if (it.isDefault == 0) {
            this.printModule = it;
            this.def = it.printTemplateDetails;
            this.htmlData = this.def;
            this.isOld = this.htmlData.includes('printTable');
            if (!this.isOld) {
              var panel = JSON.parse(this.htmlData);
              hiprintTemplate = new hiprint.PrintTemplate({
                template: panel
              });
            } else {
              var data = this.printData;
              if (data) {
                for (const key in data) {
                  if (data.hasOwnProperty(key)) {
                    const value = data[key];
                    var sres = key.trim();
                    if (sres.indexOf('DetailList') >= 0 && Array.isArray(value)) {
                      print(that, data, value);
                    }
                  }
                }
              }
            }
          }
        });
      });
      // sysPrint_getDefaultByModules({ modules: 22 }).then((res) => {
      //   this.htmlData = res.data.data.printTemplateDetails;
      //   this.isOld = this.htmlData.includes('printTable')
      //   if (!this.isOld) {
      //     var panel = JSON.parse(this.htmlData)
      //     hiprintTemplate = new hiprint.PrintTemplate({
      //       template: panel,
      //     });
      //   }
      // });
    }
  }
};
</script>

<style scoped>
.e-pr {
  width: 100%;
  top: 20%;
}
</style>
